<template>
            <cw-modal :title="translate('gebruiker_toevoegen')" :id="store.modals.USERS_ADD_USER">
                <template v-slot>
                    <form v-on:submit.prevent="inviteUser"
                          ref="inviteForm">
                        <template v-if="isLoading">
                            <div class="text-center">
                                <i class="fas fa-spinner animate-spin fa-lg"></i>
                            </div>
                        </template>
                        <template v-else>
                            <div class="grid gap-5 grid-cols-3">
                                <div class="col-span-2">
                                    <label>{{ translate('email') }}</label>
                                    <input data-val-regex-pattern="^\s?[-_.a-zA-Z0-9+]+@[-_.a-zA-Z0-9]+\.[a-zA-Z0-9]+\s?$"
                                           type="text"
                                           v-model="email"
                                           :placeholder="translate('email_address')"
                                           ref="email"/>
                                </div>
                                <div class="col-4">
                                    <label>{{ translate('language') }}</label>
                                    <select v-model="language" v-validate.required="translate('language')">
                                        <option v-for="lang in accountStore.languages" :value="lang" :key="lang">{{ lang.toUpperCase() }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="text-xs text-barometer-red bg-rust-100 px-3 py-2 rounded my-1"
                                 v-if="v$.email.$invalid && v$.email.$dirty">
                                <template v-if="v$.email.$invalid">
                                    {{ translate('validation_error_email', translate("email")) }}
                                </template>
                            </div>

                            <div v-if="!!errorMessage" class="text-xs text-barometer-red bg-rust-100 px-3 py-2 rounded my-1">
                                {{ errorMessage }}
                            </div>
                            
                            <button type="submit" class="btn btn-primary mt-4">{{ translate('uitnodigen') }}</button>

                        </template>
                    </form>
                </template>
            </cw-modal>
</template>

<script lang="ts">
import {defineComponent, nextTick} from 'vue'
import {useAccountStore} from "../store";
import {Language} from "../../../types/dto/Language";
import {InviteUserResult} from "./types";
import Ajax from "../../../lib/Ajax";
import {useVuelidate} from "@vuelidate/core";
import {email, required} from "@vuelidate/validators";

export default defineComponent({
    name: "add-user-modal",
    data() {
        return {
            accountStore: useAccountStore(),
            email: '',
            language: Language.NL as Language,
            errorMessage: '',
            isLoading: false,
            emailExists: false,
            v$: useVuelidate()
        }
    },
    validations: {
        email: {
            required,
            email
        }
    },
    computed: {
        isOpen(): boolean {
            return this.store.openedModal.contains(this.store.modals.USERS_ADD_USER);
        }
    },
    watch: {
        isOpen(val: boolean) {
            if(val) {
                nextTick(() => {
                    (this.$refs.email as HTMLInputElement).focus();
                });
            }
        }  
    },
    methods: {
        async inviteUser(): Promise<void> {
            if (this.isLoading)
                return;

            const isFormCorrect = await this.v$.$validate();

            if (!isFormCorrect)
                return;
        
            this.isLoading = true;
            try {
                const result = await Ajax.postAsync<InviteUserResult>(
                    '/ajax/account/send-invite',
                    {
                        email: this.email.trim(),
                        language: this.language
                    });
        
                this.isLoading = false;
        
                if (!result.userInvited)
                    this.errorMessage = result.notInvitedReason!;
                else if(result.userId) {
                    this.accountStore.addUser(result.userId, this.email);
        
                    this.store.closeModal();
        
                    this.errorMessage = '';
                    this.email = '';
                }
            } catch (e: unknown) {
                this.errorMessage = e as string;
                this.isLoading = false;
            }
        },
    }
});
</script>